import PedidoItemService from "@/services/PedidoItemService";

export const pedidoItem = {
  namespaced: true,
  state: {
    pedidoItem: {},
  },
  actions: {
    getPedidoItem({ commit }, payload) {
      return PedidoItemService.GetPedidoItem(payload).then(
        (pedidoItem) => {
          return Promise.resolve(pedidoItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPedidoItem({ commit }, payload) {
      return PedidoItemService.PostPedidoItem(payload).then(
        (pedidoItem) => {
          return Promise.resolve(pedidoItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPedidoItem({ commit }, payload) {
      return PedidoItemService.PutPedidoItem(payload).then(
        (pedidoItem) => {
          return Promise.resolve(pedidoItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePedidoItem({ commit }, payload) {
      return PedidoItemService.DeletePedidoItem(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPedidoItemOData({ commit }, payload) {
      return PedidoItemService.GetPedidoItemOData(payload).then(
        (pedidoItem) => {
          return Promise.resolve(pedidoItem);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default pedidoItem;
